export var RowVariants;
(function(RowVariants) {
    RowVariants["Label"] = "label";
    RowVariants["RowType"] = "rowType";
    RowVariants["Tag"] = "tag";
})(RowVariants || (RowVariants = {}));
export var getProductRow = function(product, by, name) {
    var strict = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var getBy = {
        label: function() {
            return product.rows.find(function(row) {
                return row.label === name;
            });
        },
        rowType: function() {
            return product.rows.find(function(row) {
                return row.rowType === name;
            });
        },
        tag: function() {
            return product.rows.find(function(row) {
                var ref;
                return ((ref = row.options) === null || ref === void 0 ? void 0 : ref.tag) ? strict ? row.options.tag === name : row.options.tag.includes(name) : null;
            });
        }
    };
    return Object.keys(getBy).includes(by) ? getBy[by]() : null;
};
